var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.965.543L17.284 8.96a9.63 9.63 0 00-3.299-5.235 9.238 9.238 0 00-5.74-2.06H.574v19.357h7.666a9.005 9.005 0 005.78-2.009 9.396 9.396 0 003.259-5.287l10.683 8.417 10.682-8.417v7.296h12.052v-3.929h-7.942V1.664h-4.383v7.294l-10.135 8.418-2.192-1.965 4.932-3.929 5.203-4.209-3.012-2.526-10.134 8.135-2.191-1.965 10.134-7.854L27.964.537v.006zM4.684 5.586h3.287a4.629 4.629 0 011.973.45c.624.299 1.185.72 1.651 1.238a5.945 5.945 0 011.149 1.867c.556 1.466.57 3.09.037 4.564a6.126 6.126 0 01-1.085 1.88 5.197 5.197 0 01-1.647 1.303 4.664 4.664 0 01-2.084.485H4.684V5.586zm59.708 11.508v3.928H52.338V1.664h4.382v15.43h7.672z",
    fill: "#444"
  })));
}
export default __webpack_public_path__ + "assets/static/media/Dell.f7071870.svg";
export { SvgDell as ReactComponent };